import { Box, Grid, Card, CircularProgress } from '@mui/material';
import React from 'react';

import WsColors from '../../WsColors';

const ZoomLoader = () => (
  <Box>
    <Grid item xs={12} container justifyContent="center" mt={2}>
      <Card sx={{ minHeight: 300, alignItems: 'center', width: '100%' }}>
        <Box textAlign="center" pt={15}>
          <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
        </Box>
      </Card>
    </Grid>
  </Box>
);

export default ZoomLoader;
